import { Component, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: "100vh", background: "#eaf4ff", display: "flex",
          flexDirection: "column", alignItems: "center", justifyContent: "center",
          fontFamily: "'Trebuchet MS', sans-serif", color: "#1e3a5f", padding: "20px", textAlign: "center",
        }}>
          <div style={{ fontSize: "36px", marginBottom: "16px" }}>⚠️</div>
          <div style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "8px" }}>Something went wrong</div>
          <div style={{ color: "#4b6b8a", fontSize: "14px", marginBottom: "24px" }}>
            {String(this.state.error?.message || this.state.error)}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "12px 24px", borderRadius: "14px", border: "none",
              background: "#38bdf8", color: "#fff", fontWeight: "bold",
              fontSize: "15px", cursor: "pointer",
            }}
          >
            Reload App
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.code !== 'permission-denied') return;
  // Firebase SDK v12 can create a secondary unhandled rejection even when
  // an onSnapshot error callback already handled the error. Suppress it.
  event.preventDefault();
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
